import { getAdobeScriptURL } from './helper';

window.__DATAVENTURES_PORTAL__ = {};

const setBase = () => {
	window.__DATAVENTURES_PORTAL__ = {
		dataLayer: { analyticsEvent: [], appName: 'channelPerformance' },
	};
};

const loadAdobeScript = () => {
	const adobeScriptURL = getAdobeScriptURL();

	loadScriptFile(
		adobeScriptURL,
		document.getElementsByTagName('head')[0],
		true,
		true
	);
};

const loadScriptFile = (file, appendTo, async, defer) => {
	const script = document.createElement('script');

	script.src = file;

	if (async) {
		script.async = true;
	}

	if (defer) {
		script.defer = true;
	}

	appendTo?.appendChild(script);
};

const loadContent = (appendTo) => {
	const script = document.createElement('script');

	script.type = 'text/javascript';

	appendTo?.appendChild(script);
};

const trackLoggedInUserInfo = (vendors) => {
	if (!vendors?.companyName) {
		return;
	}
	if (
		window.__DATAVENTURES_PORTAL__ &&
		window.__DATAVENTURES_PORTAL__.dataLayer
	) {
		window.__DATAVENTURES_PORTAL__.dataLayer = Object.assign(
			{},
			window.__DATAVENTURES_PORTAL__?.dataLayer,
			{
				userDetails: {
					companyName: vendors.companyName,
					LogUserInfo: `logUserInfo`,
				},
			}
		);
	} else {
		window.__DATAVENTURES_PORTAL__ = {
			dataLayer: {
				analyticsEvent: [],
				appName: 'channelPerformance',
				userDetails: {
					companyName: vendors.companyName,
					LogUserInfo: `logUserInfo`,
				},
			},
		};
	}
	triggerEvent(`logUserInfo`);
};

const trackPageInfo = (pageName) => {
	if (!pageName) {
		return;
	}
	const cPpageName = 'Channel_Performance_' + pageName;
	if (window.__DATAVENTURES_PORTAL__?.dataLayer) {
		window.__DATAVENTURES_PORTAL__.dataLayer = Object.assign(
			{},
			window.__DATAVENTURES_PORTAL__.dataLayer,
			{
				page: {
					...{
						id: pageName,
						name: cPpageName,
					},
					...{ Navigation_type: 'pageNavigation' },
				},
			}
		);
	}
};

const trackEventInfo = ({ type, actionOn, location }) => {
	window.__DATAVENTURES_PORTAL__.dataLayer = Object.assign(
		{},
		window.__DATAVENTURES_PORTAL__.dataLayer,
		{
			[type]: actionOn,
			location: location,
		}
	);
	triggerEvent(`${type}Event`);
};

const flushTrackingInfo = (info, flushWith = {}) => {
	window.__DATAVENTURES_PORTAL__.dataLayer[info] = flushWith;
	triggerEvent(`flush${info}`);
};

const triggerEvent = (type) => {
	window.__DATAVENTURES_PORTAL__?.dataLayer?.analyticsEvent?.push({
		type: type,
	});
};

export default {
	flushTrackingInfo,
	loadContent,
	loadAdobeScript,
	trackEventInfo,
	trackLoggedInUserInfo,
	trackPageInfo,
	setBase,
};
